
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class MbReport02_Dialog extends Serenity.EntityDialog<MbReport02_Row, any> {
        protected getFormKey() { return MbReport02_Form.formKey; }
        protected getIdProperty() { return MbReport02_Row.idProperty; }
        protected getLocalTextPrefix() { return MbReport02_Row.localTextPrefix; }
        protected getNameProperty() { return MbReport02_Row.nameProperty; }
        protected getService() { return MbReport02_Service.baseUrl; }
        protected getDeletePermission() { return MbReport02_Row.deletePermission; }
        protected getInsertPermission() { return MbReport02_Row.insertPermission; }
        protected getUpdatePermission() { return MbReport02_Row.updatePermission; }

        protected form = new MbReport02_Form(this.idPrefix);
        
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }

    }
}